import { render } from "./ctrl-bet-box-group.vue?vue&type=template&id=caf4f3b6&scoped=true&ts=true"
import script from "./ctrl-bet-box-group.vue?vue&type=script&lang=ts"
export * from "./ctrl-bet-box-group.vue?vue&type=script&lang=ts"

import "./ctrl-bet-box-group.vue?vue&type=style&index=0&id=caf4f3b6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf4f3b6"]])

export default __exports__